import React, { forwardRef } from 'react';

import MUIFormControl, {
  FormControlProps as MUIFormControlProps,
} from '@material-ui/core/FormControl';

interface FormControlProps extends MUIFormControlProps {}

const FormControl = forwardRef<HTMLDivElement, FormControlProps>(
  (props, ref) => {
    return (
      <MUIFormControl {...props} ref={ref}>
        {props.children}
      </MUIFormControl>
    );
  }
);

FormControl.displayName = 'FormControl';

export default FormControl;
